import { Link, Outlet } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { AnnouncementBar, Navbar } from "@/components/layout/Navbar";

const COLS = [
  ["For Job Seekers", [["Search jobs in India", "/jobs"], ["Jobs by category", "/categories"], ["Create a free profile", "/signup"], ["Salary guides by role & city", "/salaries"], ["Career guides & resources", "/career-resources"]]],
  ["For Employers", [["Post a job for free", "/signup?role=employer"], ["Hiring solutions for employers", "/for-employers"], ["Plans & pricing", "/pricing"], ["Companies hiring now", "/companies"]]],
  ["For Colleges", [["Partner as a placement cell", "/signup?role=college"], ["Campus drive management", "/for-colleges"], ["Placement tracking for colleges", "/for-colleges"]]],
  ["Company", [["About Jobfixnow", "/about"], ["Frequently asked questions", "/faq"], ["Privacy policy", "/privacy-policy"], ["Terms & conditions", "/terms"]]],
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B1B2B] text-white">
      <div className="container-x grid grid-cols-2 gap-8 py-12 sm:py-14 md:grid-cols-[1.4fr_repeat(4,1fr)] md:gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo dark />
          <p className="mt-4 max-w-xs text-sm text-white/70">A career platform for every ambition. Connecting talent with opportunities across India.</p>
          <p className="mt-3 text-sm font-semibold tracking-wide text-[#00B94F]">WE FIND. YOU GROW.</p>
        </div>
        {COLS.map(([h, links]) => (
          <div key={h}>
            <h2 className="text-sm font-semibold">{h}</h2>
            <ul className="mt-4 space-y-2.5">
              {links.map(([l, to]) => <li key={l}><Link to={to} className="text-sm text-white/65 transition-colors hover:text-[#00B94F]">{l}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-white/55 sm:flex-row">
          <span>© {new Date().getFullYear()} Jobfixnow. All rights reserved.</span>
          <span>India · A platform for a stronger, brighter workforce</span>
        </div>
      </div>
    </footer>
  );
}

export default function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
